import React, {useState} from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    IconButton,
    Typography
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import CategoryManager from "./CategoryManager";

export default function CategoryManagerCard() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button
                style={{backgroundColor: "black", borderRadius: '999px', padding: '10px 12px',}}
                variant="contained"
                onClick={() => setOpen(true)}
            >
                Kategorien verwalten
            </Button>

            {open && (
                <Box
                    sx={{
                        position: "fixed",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(0, 0, 0, 0.65)",
                        zIndex: 1300,
                        p: 2
                    }}
                    onClick={() => setOpen(false)}
                >
                    <Card
                        sx={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            borderRadius: 3,
                            overflow: "hidden"
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                p: 2,
                                borderBottom: 1,
                                borderColor: "divider"
                            }}
                        >
                            <Typography variant="h6">
                                Kategorien verwalten
                            </Typography>

                            <IconButton onClick={() => setOpen(false)}>
                                <CloseIcon/>
                            </IconButton>
                        </Box>

                        <CardContent sx={{overflowY: "auto", flex: 1}}>
                            <CategoryManager/>
                        </CardContent>
                    </Card>
                </Box>
            )}
        </>
    );
}